/**
 * @generated SignedSource<<4476c574ab7fa407d8be134d3345964c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectoryFeeBlock_agent$data = {
  readonly fees: {
    readonly feesIncludeVat: boolean | null | undefined;
    readonly inventory: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly letOnly: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly management: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly renewal: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly rentCollection: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly tenantFind: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly name: string | null | undefined;
  readonly slug: string | null | undefined;
  readonly sources: {
    readonly feesIncludeVat: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "DirectoryFeeBlock_agent";
};
export type DirectoryFeeBlock_agent$key = {
  readonly " $data"?: DirectoryFeeBlock_agent$data;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryFeeBlock_agent">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amountPence",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percent",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceUrls",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feesIncludeVat",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DirectoryFeeBlock_agent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAgentFees",
      "kind": "LinkedField",
      "name": "fees",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "management",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "rentCollection",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "tenantFind",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "letOnly",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "renewal",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "inventory",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        (v1/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAgentSources",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": [
        (v1/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "LandlordDirectoryAgent",
  "abstractKey": null
};
})();

(node as any).hash = "1c868ad09e74052cb273ec65921b3064";

export default node;
